<template>
  <div class="amprod-error">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "ErrorMessage",
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.amprod-error {
  color: #d32f2f;
  background-color: #fde8e8;
  padding: 15px;
  border-radius: 4px;
  margin: 20px 0;
}
</style>
